






















































declare var google: any;
import { Component, Vue } from 'vue-property-decorator';
import Api from '../services/Api';

@Component
export default class Nilai extends Vue {
  private apiService: Api = new Api();
  private spinner: boolean = false;
  private mapel: string = '';
  private data: any = {};
  
  constructor() {
    super();
  }

  created() {
    this.mapel = localStorage.getItem('mapel') || '';
  }

  mounted() {
    this.getNilai();
  }

  drawChart() {
    var data = google.visualization.arrayToDataTable([
      ['Data', 'Nilai'],
      ['Benar',     this.data.benar],
      ['Salah',      this.data.salah],
      ['Dilewati',  this.data.dilewati]
    ]);

    var options = {
      // title: 'Data Jawaban Tes'
    };

    var chart = new google.visualization.PieChart(document.getElementById('piechart'));
    chart.draw(data, options);
  }

  getNilai(): void {
    this.spinner = true;
    this.apiService.postResource('/nilai', {
      username: localStorage.getItem('username'),
      mapel: localStorage.getItem('mapel')
    }, true).then(r => {
      this.spinner = false;
      this.data = r.data;
      google.charts.load('current', {'packages':['corechart']});
      google.charts.setOnLoadCallback(this.drawChart);
    }).catch(err => {
      this.spinner = false;
      this.$toast.error('GAGAL MENGAMBIL NILAI');
    });
  }

  logout(): void {
    localStorage.removeItem('shownilai');
    localStorage.removeItem('token');
    localStorage.removeItem('mapel');
    localStorage.removeItem('username');
    localStorage.removeItem('dikerjakan');
    localStorage.removeItem('ragu');
    this.$router.replace('/');
  }
}
